/* ITT — Spatial News Carousel (UI-REPAIR 2026-10-31).
   The cube's news face opens into a ring of floating 3D cards rendered
   from TODAY'S compiled front page (data parsed in the section from
   pages['headline-of-the-day'] — the compile is the source of truth;
   nothing here fetches an external news API and no headline is
   hardcoded). Click/tap or drag to turn the ring; the focused story
   syncs the Headline Shirt dock below. Focus easing is the pasted
   spec's TWEEN contract (Cubic.Out, 800ms) implemented locally —
   TWEEN.js is not vendored in this workspace; Three.js r160 IS
   vendored (see itt-three-loader.js). House styling: paper/ink, real
   shadows, no glassmorphism. If WebGL or the vendored library cannot
   start, the chips + dock still work as a flat story switcher and the
   cube above is untouched. */
(function () {
  'use strict';
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var roots = document.querySelectorAll('[data-cube-root]');
  for (var r = 0; r < roots.length; r++) init(roots[r]);

  function cubicOut(t) { return 1 - Math.pow(1 - t, 3); }

  function init(root) {
    var openBtn = root.querySelector('[data-n3d-open]');
    var region = root.querySelector('[data-n3d]');
    if (!openBtn || !region) return;
    var stage = region.querySelector('[data-n3d-stage]');
    var msg = region.querySelector('[data-n3d-msg]');
    var dock = region.querySelector('[data-n3d-dock]');
    var chipsWrap = region.querySelector('.itt-n3d-chips');
    var closeBtn = region.querySelector('[data-n3d-close]');
    var dataEl = root.querySelector('[data-n3d-data]');
    var data = null;
    try { data = JSON.parse(dataEl ? dataEl.textContent : ''); } catch (e) { data = null; }
    if (!data || !data.cards || !data.cards.length) { openBtn.style.display = 'none'; return; }
    var cards = data.cards;
    var focus = 0;
    var started = false, failed = false;
    var T = null, renderer = null, scene = null, camera = null, ring = null;
    var cardGroups = [], raycaster = null, raf = 0, tween = null, dragInfo = null;
    var fpsFrames = 0, fpsTime = 0, fps = 0;

    /* ---------- dock + chips (work with or without WebGL) ---------- */
    function el(tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text != null) n.textContent = text;
      return n;
    }
    function setDock(i) {
      focus = i;
      var c = cards[i];
      dock.textContent = '';
      var story = el('p', 'itt-n3d-dock-story');
      var k = el('span', 'itt-n3d-dock-kicker', c.kicker);
      k.style.color = c.color || '#1E1B16';
      story.appendChild(k);
      story.appendChild(el('span', 'itt-n3d-dock-title', c.title || ''));
      dock.appendChild(story);
      var shirt = el('p', 'itt-n3d-dock-shirt');
      shirt.appendChild(el('b', null, 'Headline Shirt'));
      shirt.appendChild(document.createTextNode(' — “' + (data.headline || '') + '” '));
      shirt.appendChild(el('span', 'itt-n3d-shirt-state',
        'Status: today’s headline, not yet on a shirt. A headline becomes a shirt only when the founder calls it — never automatically, and no product is created from this page.'));
      dock.appendChild(shirt);
      var read = el('a', 'itt-n3d-dock-read', 'Read the full front page');
      read.href = '/pages/headline-of-the-day';
      dock.appendChild(read);
      Array.prototype.forEach.call(chipsWrap.children, function (chip, j) {
        chip.setAttribute('aria-pressed', j === i ? 'true' : 'false');
      });
    }
    cards.forEach(function (c, i) {
      var chip = el('button', 'itt-n3d-chip', c.kicker);
      chip.type = 'button';
      chip.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
      chip.addEventListener('click', function () { focusCard(i, true); });
      chipsWrap.appendChild(chip);
    });

    /* ---------- WebGL ring ---------- */
    function wrapText(ctx, text, x, y, maxW, lineH, maxLines) {
      var words = String(text || '').split(/\s+/);
      var line = '', lines = 0;
      for (var i = 0; i < words.length; i++) {
        var test = line ? line + ' ' + words[i] : words[i];
        if (ctx.measureText(test).width > maxW && line) {
          ctx.fillText(line, x, y); lines++; y += lineH; line = words[i];
          if (lines >= maxLines) return y;
        } else line = test;
      }
      if (line && lines < maxLines) { ctx.fillText(line, x, y); y += lineH; }
      return y;
    }
    function cardTexture(c) {
      var cv = document.createElement('canvas');
      cv.width = 640; cv.height = 400;
      var x = cv.getContext('2d');
      x.fillStyle = '#FFFDF8'; x.fillRect(0, 0, 640, 400);
      x.strokeStyle = '#1E1B16'; x.lineWidth = 5; x.strokeRect(10, 10, 620, 380);
      x.strokeStyle = c.color || '#1E1B16'; x.lineWidth = 3; x.strokeRect(22, 22, 596, 356);
      x.fillStyle = c.color || '#1E1B16';
      x.font = '700 25px "Avenir Next", system-ui, sans-serif';
      x.fillText(String(c.kicker || '').toUpperCase(), 44, 74);
      x.fillStyle = '#1E1B16';
      x.font = '800 39px Georgia, "Times New Roman", serif';
      var y = wrapText(x, c.title || '', 44, 122, 552, 44, 3);
      x.fillStyle = '#D9C8A9'; x.fillRect(44, y + 2, 552, 3);
      x.fillStyle = '#33302A';
      x.font = '23px "Avenir Next", system-ui, sans-serif';
      var bodyStart = y + 34;
      var bodyLines = Math.max(2, Math.floor((348 - bodyStart) / 31));
      wrapText(x, c.body || '', 44, bodyStart, 552, 31, bodyLines);
      x.fillStyle = '#6E6353';
      x.font = '600 19px "Avenir Next", system-ui, sans-serif';
      x.fillText('CHUNWU NEWS · THE FRONT PAGE', 44, 366);
      var tex = new T.CanvasTexture(cv);
      tex.anisotropy = 4;
      return tex;
    }
    function fitCamera() {
      if (!renderer || !camera) return;
      var w = stage.clientWidth || 600, h = stage.clientHeight || 400;
      renderer.setSize(w, h, false);
      camera.aspect = w / h;
      var need = (3.2 * 1.14 / 0.84) / (2 * Math.tan((camera.fov * Math.PI / 180) / 2) * camera.aspect);
      camera.position.z = 4.5 + Math.max(3.9, need);
      camera.updateProjectionMatrix();
    }
    function targetFor(i) {
      var stepA = (Math.PI * 2) / cards.length;
      var want = -i * stepA;
      var cur = ring.rotation.y;
      var diff = ((want - cur) % (Math.PI * 2) + Math.PI * 3) % (Math.PI * 2) - Math.PI;
      return cur + diff;
    }
    function focusCard(i, animate) {
      i = ((i % cards.length) + cards.length) % cards.length;
      setDock(i);
      if (!ring) return;
      var dur = RM || !animate ? 0 : 800;
      if (dur === 0) { ring.rotation.y = targetFor(i); tween = null; return; }
      tween = { from: ring.rotation.y, to: targetFor(i), start: performance.now(), dur: dur };
    }
    function nearestIndex() {
      var stepA = (Math.PI * 2) / cards.length;
      return ((Math.round(-ring.rotation.y / stepA) % cards.length) + cards.length) % cards.length;
    }
    function startGL(THREE) {
      T = THREE;
      renderer = new T.WebGLRenderer({ antialias: true });
      renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
      scene = new T.Scene();
      scene.background = new T.Color(0xFFF8EF);
      scene.fog = new T.Fog(0xFFF8EF, 12, 20);
      camera = new T.PerspectiveCamera(50, 1.6, 0.1, 60);
      camera.position.set(0, 0.35, 8.6);
      camera.lookAt(0, 0, 0);
      ring = new T.Group();
      scene.add(ring);
      var RADIUS = 4.5, stepA = (Math.PI * 2) / cards.length;
      cards.forEach(function (c, i) {
        var g = new T.Group();
        var a = i * stepA;
        g.position.set(Math.sin(a) * RADIUS, 0, Math.cos(a) * RADIUS);
        /* The yaw subgroup turns each card part-way toward the viewer
           (see loop): purely radial facing puts the ±72deg neighbours
           past the visibility cone at this camera distance — they were
           backface-culled out of the render AND the raycast. */
        var yaw = new T.Group();
        g.add(yaw);
        var shadow = new T.Mesh(
          new T.PlaneGeometry(3.36, 2.16),
          new T.MeshBasicMaterial({ color: 0x1E1B16, transparent: true, opacity: 0.16, depthWrite: false })
        );
        shadow.position.set(0.07, -0.09, -0.05);
        yaw.add(shadow);
        var m = new T.Mesh(
          new T.PlaneGeometry(3.2, 2.0),
          new T.MeshBasicMaterial({ map: cardTexture(c) })
        );
        m.userData.index = i;
        yaw.add(m);
        ring.add(g);
        cardGroups.push({ group: g, yaw: yaw, mesh: m, angle: a });
      });
      raycaster = new T.Raycaster();
      stage.appendChild(renderer.domElement);
      fitCamera();
      if (window.ResizeObserver) new ResizeObserver(fitCamera).observe(stage);
      window.addEventListener('resize', fitCamera);
      bindPointer();
      fpsTime = performance.now();
      loop();
    }
    function loop() {
      raf = requestAnimationFrame(loop);
      var now = performance.now();
      fpsFrames++;
      if (now - fpsTime >= 500) { fps = Math.round(fpsFrames * 1000 / (now - fpsTime)); fpsFrames = 0; fpsTime = now; }
      if (tween) {
        var t = Math.min(1, (now - tween.start) / tween.dur);
        ring.rotation.y = tween.from + (tween.to - tween.from) * cubicOut(t);
        if (t >= 1) tween = null;
      }
      var tSec = now / 1000;
      cardGroups.forEach(function (cg, i) {
        var world = cg.angle + ring.rotation.y;
        var wn = Math.atan2(Math.sin(world), Math.cos(world));
        var front = Math.cos(world);
        var s = 1 + 0.12 * Math.max(0, front);
        cg.group.scale.set(s, s, 1);
        var shade = 0.60 + 0.40 * Math.max(0, front);
        cg.mesh.material.color.setScalar(shade);
        /* face each card 55% of the way from front-facing to radial:
           the focused card (world angle 0) ends up perfectly front,
           neighbours stay readable and clickable. */
        cg.yaw.rotation.y = 0.55 * wn - ring.rotation.y;
        cg.group.position.y = RM ? 0 : Math.sin(tSec * 1.4 + i * 1.7) * 0.07;
      });
      renderer.render(scene, camera);
    }
    function bindPointer() {
      var dom = renderer.domElement;
      var downAt = null, moved = false;
      dom.addEventListener('pointerdown', function (e) {
        downAt = { x: e.clientX, rot: ring.rotation.y };
        moved = false;
        tween = null;
      });
      window.addEventListener('pointermove', function (e) {
        if (!downAt) return;
        var dx = e.clientX - downAt.x;
        if (Math.abs(dx) > 5) moved = true;
        if (moved) ring.rotation.y = downAt.rot + dx * 0.005;
      });
      window.addEventListener('pointerup', function (e) {
        if (!downAt) return;
        var wasDrag = moved;
        downAt = null;
        if (wasDrag) { focusCard(nearestIndex(), true); return; }
        var rect = dom.getBoundingClientRect();
        var v = new T.Vector2(((e.clientX - rect.left) / rect.width) * 2 - 1, -((e.clientY - rect.top) / rect.height) * 2 + 1);
        raycaster.setFromCamera(v, camera);
        var hits = raycaster.intersectObjects(cardGroups.map(function (cg) { return cg.mesh; }));
        if (hits.length) focusCard(hits[0].object.userData.index, true);
      });
      stage.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); focusCard(focus + 1, true); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); focusCard(focus - 1, true); }
      });
    }
    function stopGL() {
      if (raf) cancelAnimationFrame(raf);
      raf = 0; tween = null; dragInfo = null;
      if (renderer) {
        renderer.dispose();
        if (renderer.domElement && renderer.domElement.parentNode) renderer.domElement.parentNode.removeChild(renderer.domElement);
      }
      renderer = null; scene = null; camera = null; ring = null; cardGroups = [];
      started = false;
    }

    /* ---------- open / close ---------- */
    function openRegion() {
      region.hidden = false;
      openBtn.setAttribute('aria-expanded', 'true');
      setDock(focus);
      if (started || failed) { if (started) fitCamera(); return; }
      started = true;
      msg.hidden = false;
      msg.textContent = 'Loading the front page in 3D…';
      if (!window.ITTThree) { failStart(); return; }
      window.ITTThree.load(region.getAttribute('data-n3d-parts')).then(function (THREE) {
        try {
          startGL(THREE);
          msg.hidden = true;
          focusCard(focus, false);
        } catch (err) { failStart(); }
      }).catch(function () { failStart(); });
    }
    function failStart() {
      failed = true; started = false;
      msg.hidden = false;
      msg.textContent = 'The 3D view could not start on this device. The stories still switch below — and today’s front page is on the cube above.';
    }
    openBtn.addEventListener('click', function () {
      if (region.hidden) openRegion();
      else { region.hidden = true; openBtn.setAttribute('aria-expanded', 'false'); stopGL(); }
    });
    if (closeBtn) closeBtn.addEventListener('click', function () {
      region.hidden = true;
      openBtn.setAttribute('aria-expanded', 'false');
      stopGL();
      openBtn.focus();
    });
    setDock(0);
    window.__ittN3D = function () {
      return {
        ready: !!renderer, failed: failed, focus: focus, fps: fps,
        ringRot: ring ? +ring.rotation.y.toFixed(3) : null,
        path: window.__ITT_THREE_PATH__ || null,
        cardPoint: function (i) {
          if (!renderer || !cardGroups[i]) return null;
          var v = new T.Vector3();
          cardGroups[i].group.getWorldPosition(v);
          v.project(camera);
          var rect = renderer.domElement.getBoundingClientRect();
          return { x: rect.left + (v.x + 1) / 2 * rect.width, y: rect.top + (-v.y + 1) / 2 * rect.height, behind: v.z > 1 };
        },
        pick: function (clientX, clientY) {
          if (!renderer || !raycaster) return null;
          var rect = renderer.domElement.getBoundingClientRect();
          var v = new T.Vector2(((clientX - rect.left) / rect.width) * 2 - 1, -((clientY - rect.top) / rect.height) * 2 + 1);
          raycaster.setFromCamera(v, camera);
          var hits = raycaster.intersectObjects(cardGroups.map(function (cg) { return cg.mesh; }));
          return hits.map(function (h) { return h.object.userData.index; });
        }
      };
    };
  }
})();
